<div class="background"><slot /></div>

<style>
    .background {position: absolute;left: 0;width: 100%;z-index: -1;}
</style>
